import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbWindowModule
} from '@nebular/theme';
import { NgSelectModule, NgSelectConfig } from '@ng-select/ng-select';
import { AuthGuard } from './auth/guards/auth.guard';
import { PagesGuard } from './auth/guards/pages.guard';
import { CanActivateForEntityGuard } from './auth/guards/can-activate-for-entity.guard';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    NgSelectModule
  ],
  providers: [AuthGuard, PagesGuard, CanActivateForEntityGuard, NgSelectConfig],
  bootstrap: [AppComponent]
})
export class AppModule {}
